import React, { Component }                      from 'react'
import { NavLink, Redirect, Route, Switch }      from 'react-router-dom'
import NoResult                                  from '../../../components/NoResult'
import MajorItem                                 from '../../../components/MajorItem'
import Search                                    from '../../../components/Search'
import { getMajors }                             from '../../../api/major'
import Catgory                                   from './Catgory'
import Classify                                  from './Classify'
import { CAT_COLLEGE, CAT_UNDERGRADUATE, LIMIT } from '../constants/index'
import './index.less'

const paramReset = {
  limit: LIMIT,
  page: 1,
  _s_type: null,
  _s_category_id: null,
  _s_classifiy_id: null,
  _s_name: null,
}

class MajorList extends Component {

  state = {
    searchVal: '',
    lastPage: false,
    searchResult: [],
    param: paramReset,
    loading: false,
  }

  searchInput = null

  handleSearch(value) {
    const param = {
      _s_name: value,
    }
    this.setState({
      searchVal: value,
      loading: Boolean(value),
    })
    if (value) {
      getMajors(param).then(res => {
        this.setState({
          searchResult: res.data,
          lastPage: res.lastPage,
        })
      }).finally(() => {
        this.setState({
          loading: false,
        })
      })
    }
  }

  handleMajorClick(major) {
    this.props.history.push(`/major/detail/${major.id}`)
  }

  handleResetSearch() {
    const { history } = this.props
    this.searchInput.reset()
    history.replace(`/major/list/undergraduate`)
  }

  renderSearchResult() {
    const { searchResult } = this.state
    const { history } = this.props
    if (Array.isArray(searchResult) && searchResult.length) {
      return (
        <div className="major-list-outter search-result">
          {searchResult.map((d, i) =>
            <MajorItem
              key={i}
              major={d}
              history={history}/>
          )}
        </div>
      )
    } else {
      return <NoResult
        prompt1="对不起"
        prompt2="没有匹配到合适的专业哦"
        resetBtnText="从一级类目挑选专业"
        onResetSearch={this.handleResetSearch.bind(this)}
      />
    }
  }

  render() {
    const { match } = this.props
    const { searchVal, loading } = this.state
    return (
      <div className="major-list-wrapper">
        <Search
          ref={ref => this.searchInput = ref}
          placeholder="搜索你想了解的专业"
          onSearch={this.handleSearch.bind(this)}
        />
        {searchVal && !loading
          ? this.renderSearchResult()
          : <div className="major-list-outter">
            <div className="tab">
              <NavLink to={`${match.url}/undergraduate`} activeClassName="active" replace>本科</NavLink>
              <NavLink to={`${match.url}/college`} activeClassName="active" replace>专科</NavLink>
            </div>
            <Switch>
              <Route path={`${match.url}/college/:id`} render={props =>
                <Classify type={CAT_COLLEGE} onMajorClick={this.handleMajorClick.bind(this)} {...props} />
              }/>
              <Route path={`${match.url}/college`} render={props =>
                <Catgory type={CAT_COLLEGE} {...props} />
              }/>
              <Route path={`${match.url}/undergraduate/:id`} render={props =>
                <Classify type={CAT_UNDERGRADUATE} onMajorClick={this.handleMajorClick.bind(this)} {...props} />
              }/>
              <Route path={`${match.url}/undergraduate`} render={props =>
                <Catgory type={CAT_UNDERGRADUATE} {...props} />
              }/>
              <Redirect exact from={match.url} to={`${match.url}/undergraduate`}/>
            </Switch>
          </div>
        }
      </div>
    )
  }
}


export default MajorList



// WEBPACK FOOTER //
// ./src/pages/Major/List/index.js